import { isBrowser } from "../utils/index";

const needHoldEvents: Array<"click"> = ["click"]; //, "input"
interface CatchEventCallBack {
  (evt: MouseEvent): void;
}

const fns: Array<CatchEventCallBack> = [];

const eventHandle: CatchEventCallBack = function(e: MouseEvent) {
  fns.forEach(fn => fn(e));
};

needHoldEvents.forEach(function(eventName) {
  if (isBrowser()) {
    document.addEventListener(eventName, eventHandle, true); // the third argument must be true
  }
});

export default function eventCatch(fn: CatchEventCallBack) {
  fns.push(fn);
}
